<div class="top-0 left-0 w-full h-auto z-50 fixed flex flex-col items-center">
  <div
    class="h-16 w-[95%] lg:w-[85%] max-w-[1450px] inline-flex justify-between items-center px-5 lg:px-8 xl:px-10 rounded-b-[25px] lg:rounded-b-[50px] bg-secondary-200 shadow-2xl">
    <div class="w-[150px] object-cover relative">
      <img alt="pw-navbar-logo" [src]="logotypeUrl()" class="h-auto object-cover">
    </div>
    <div class="flex-grow-1 hidden md:inline-flex justify-center">
      <ul class="mx-auto inline-flex justify-around gap-4 font-secondary uppercase text-secondary-700 text-xs">
        @for (section of sections(); track $index) {
          <li class="hover:text-primary-600 cursor-pointer transition-all duration-500 select-none"
              [navigator]="section.id" [navigatorDuration]="4">{{ section.label }}
          </li>
        }
      </ul>
    </div>
    <div class="w-[150px] hidden md:inline-flex justify-end gap-2">
      <p-button
        [autofocus]="false"
        [navigator]="formSectionId()"
        [rounded]="true"
        i18n-label="@@button.apply"
        label="ZAPYTANIE"
        styleClass="text-sm !py-2 !px-4">
      </p-button>

      @if (phone()) {
        <p-button
          [autofocus]="false"
          rounded
          outlined
          icon="pi pi-phone"
          class="relative"
          (click)="onPhoneButtonClick()"
          styleClass="text-sm !py-2 !px-4">
        </p-button>
      }
    </div>
    <p-button
      (click)="isMenuToggled = !isMenuToggled; trackApplicationCta()"
      [autofocus]="false"
      severity="contrast"
      styleClass="block md:hidden p-fab text-secondary-600"
      variant="text">
      <ng-icon name="tablerMenu2" size="1.5rem"></ng-icon>
    </p-button>
  </div>

  <p-drawer
    ngSkipHydration
    [(visible)]="isMenuToggled"
    position="bottom"
    styleClass="h-[60dvh]"
    closable="true">
    <ul
      class="h-auto flex flex-col justify-start items-center gap-4 font-secondary uppercase text-secondary-700 text-lg">
      @for (section of sections(); track $index) {
        <li class="hover:text-primary-600 cursor-pointer transition-all duration-500 select-none text-center"
            [navigator]="section.id" (click)="onClose()">{{ section.label }}
        </li>
      }
    </ul>
    <div class="w-full h-fit mt-5 inline-flex justify-center items-center">
      <p-button
        (click)="trackApplicationCta()"
        [rounded]="true"
        [navigator]="formSectionId()"
        [autofocus]="false"
        i18n-label="@@button.apply"
        label="ZAPYTANIE"
        styleClass="text-md">
      </p-button>
    </div>
  </p-drawer>
</div>

<p-drawer
  ngSkipHydration
  [(visible)]="isMenuToggled"
  position="bottom"
  styleClass="h-[60dvh]"
  closable="true">
  <ng-template pTemplate="content">
    <ul
      class="h-auto flex flex-col justify-start items-center gap-4 font-secondary uppercase text-secondary-700 text-lg">
      @for (section of sections(); track $index) {
        <li class="hover:text-primary-600 cursor-pointer transition-all duration-500 select-none text-center"
            [navigator]="section.id" (click)="onClose()">{{ section.label }}
        </li>
      }
    </ul>
    <div class="w-full h-fit mt-5 inline-flex justify-center items-center">
      <p-button
        (click)="trackApplicationCta()"
        [rounded]="true"
        [navigator]="formSectionId()"
        [autofocus]="false"
        i18n-label="@@button.apply"
        label="ZAPYTANIE"
        styleClass="text-md">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
